import React from 'react';
import './LoadingSpinner.css';

export function LoadingSpinner({ message }) {
  return (
    <div className="loading-container">
      <div className="loading-spinner">
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
      </div>
      <p className="loading-text">{message || 'Loading...'}</p>
    </div>
  );
}

export default LoadingSpinner;
